import { object, string } from 'yup';

import { messages, regExEmail, trim } from '../../../data/utils/form.utils';

/**
 * Every patient logs in with their own address. Left empty, the person becomes
 * a patient without the app, such as a child without an address of its own.
 */
export const emailSchema = object()
  .shape({
    email: string()
      .transform(trim)
      .email(messages.invalidEmail.id)
      .matches(regExEmail, {
        message: messages.invalidRegEx.id,
        excludeEmptyString: true,
      })
      .default(''),
  })
  .required()
  .noUnknown();
